module.exports = __webpack_public_path__ + "img/gp.24841de9.svg";